import React from "react";
import { Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4">
          Témoignages
        </p>
        <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-neutral-900 leading-tight max-w-3xl mb-14">
          Ce que disent les entreprises qui <span className="text-brand">nous font confiance.</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.company} className="bg-neutral-50 border border-neutral-200 rounded-2xl p-7 flex flex-col">
              <Quote size={28} className="text-brand/30" />
              <p className="mt-4 text-neutral-700 leading-relaxed flex-1">“{t.quote}”</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-neutral-200">
                <div className="bg-brand text-white rounded-full w-11 h-11 flex items-center justify-center font-heading font-bold">
                  {t.initials}
                </div>
                <div>
                  <p className="font-semibold text-neutral-900 text-sm">{t.name}</p>
                  <p className="text-xs text-neutral-500">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
